export const environment = {
  production: true,
  api_domain: 'api.imagebase.pro',
  api_url: 'https://api.imagebase.pro/api/',
  plugins: [],
  facebook: 'https://www.facebook.com/imagebase.pro',
  instagram: 'https://www.instagram.com/imagebase.pro',
  twitter: 'https://x.com/',
  app_store: 'https://apps.apple.com/',
  google_play: 'https://play.google.com/store/',
  support_email: 'support@imagebase.io',
  web: {
    client_id:
      '536561358413-kvg2sb5rrqmumdup0tojqctd4d8hiioo.apps.googleusercontent.com',
    redirect_uri: 'https://imagebase.pro/auth/check-oauth-token',
  },
};
